import React from 'react'

const IconFrpa = (props) => {
  const {active} = props

  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24'>
      <path
        fill={`${active ? '#eeeeee' : '#d54c00'}`}
        d='M5.5 12.089q0 1.218.462 2.37q.463 1.15 1.442 2.126l1.019 1.019v-2.527q0-.212.144-.356t.357-.144t.356.144t.143.356v3.462q0 .343-.232.575t-.576.232H5.154q-.213 0-.356-.144t-.144-.356t.144-.356t.356-.144H7.75l-1.054-1.042q-1.165-1.131-1.68-2.485q-.516-1.354-.516-2.73q0-2.177 1.123-3.984t3.014-2.793q.196-.104.41-.045q.215.06.282.262q.067.188-.011.389q-.078.2-.277.307q-1.624.858-2.582 2.42Q5.5 10.208 5.5 12.09m13-.177q0-1.22-.462-2.37q-.463-1.151-1.442-2.126l-1.019-1.02v2.527q0 .213-.144.356t-.357.144t-.356-.144t-.143-.356V5.462q0-.344.232-.576t.576-.232h3.461q.213 0 .357.144t.143.357t-.143.356t-.357.143H16.25l1.054 1.042q1.145 1.145 1.67 2.488q.526 1.343.526 2.73q0 2.175-1.113 3.972q-1.114 1.797-3.004 2.783q-.196.104-.411.054t-.281-.251q-.068-.19.012-.391q.08-.202.257-.306q1.623-.858 2.581-2.42q.959-1.563.959-3.443'
      />
    </svg>
  )
}

export default IconFrpa